import React, { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import QuickMenu from "./QuickMenu";
import { quickMenuMap } from "../../../utils/mapper/mappers";
import FileUploadModal from "../../../components/modals/FileUploadModal";
import { getAccountPathByName } from "../../../utils/helpers/getAccountTypeName";
import TokenHelpers from "../../../utils/helpers/tokenHelper";

export default function QuickMenuCard({ name }) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);
  const account_type = TokenHelpers.getFromStorage("account_type");
  const account_path = getAccountPathByName(account_type);

  const routeToPage = (item) => {
    if (item.nameConst === "UPLOAD_MEMBERS") {
      setOpen(true);
    } else {
      history.push(`/dashboard${account_path}${item.to}`, { text: item.name });
    }
  };

  return (
    <div className="w-screen md:w-full mb-5 bg-white rounded-lg border border-gray-200 shadow-md">
      <h5 className="rounded-t-lg p-2 mb-2 text-xl font-bold bg-green-800  text-white">
        {name}
      </h5>
      {/* <div className="flex justify-between flex-wrap font-normal text-gray-700 dark:text-gray-400 p-6"> */}
      <div className="flex flex-wrap font-normal text-gray-700 dark:text-gray-400 p-6 gap-5">
        {quickMenuMap.map((item, index) => {
          return (
            <QuickMenu
              key={index}
              item={item}
              routeToPage={(e) => routeToPage(e)}
            />
          );
        })}
      </div>
      <FileUploadModal
        open={open}
        setOpen={setOpen}
        cancelButtonRef={cancelButtonRef}
      />
    </div>
  );
}
